import type { AccountTransactionsQueryOptions } from '../ui/ManagerFinance/AccountTransactions/types'
import { callApi } from './api/finance-api'

export const _getAccountTransactions = async (
	data: AccountTransactionsQueryOptions,
) => {
	return callApi('/v1/account-transactions', {
		method: 'POST',
		body: {
			...data,
		},
	})
}
